import { Icon, Tooltip, IconButton } from "@/components";

interface APYDisplayProps {
    className?: string;
    isJunior?: boolean;
}

export function TrancheDisplay({ className, isJunior }: APYDisplayProps) {
    const tooltipText = isJunior
        ? "Higher risk - positions in the Junior Tranche receive higher returns, but take first-loss in the event of any slashing caused by loss of underlying capital in associated protocols."
        : "Lower risk - positions in the Senior Tranche are insured against loss of underlying capital by the Junior Tranche";

    return (
        <Tooltip title={tooltipText}>
            <div className={`flex items-center gap-1 relative ${className}`}>
                <span className="text-dark text-[12px]">{isJunior ? "Junior Tranche" : "Senior Tranche"}</span>
                <span className="inline-block cursor-help">
                    <IconButton size="sm" variant="ghost" className="p-0">
                        <Icon name="Info" className="text-dark text-xs w-[14px] h-[14px] " />
                    </IconButton>
                </span>
            </div>
        </Tooltip>
    );
}
